import { isValidEmail } from '../../../services/UtilService';
import { dbPost } from '../../../apis/commonApi';

class ExpertConsultController {
  initialState = {
    picNm: '',
    taskNm: '',
    status: '',
    currentPage: '',
    pageSize: '',
  };

  constructor(
    store,
    modalService,
    validateService,
    [gridRef],
    { valueObj, setValueObj },
    { selectBoxData, setSelectBoxData },
    navigate
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.gridRef = gridRef;
    this.valueObj = { ...this.initialState, ...valueObj };
    this.setValueObj = setValueObj;
    this.selectBoxData = selectBoxData;
    this.setSelectBoxData = setSelectBoxData;
    this.navigate = navigate;
    this.gridCellClick = this.gridCellClick.bind(this);
    this.gridCellDblClick = this.gridCellDblClick.bind(this);
  }

  // 조회
  async fnSearch() {
    const { picNm, taskNm, processStatus } = this.valueObj;
    const url = '/expert-consult/list.do';
    const param = {
      picNm,
      userNm: picNm,
      taskNm,
      status: processStatus,
      currentPage: 1,
      pageSize: 10,
    };
    this.gridRef.current.doQuery(url, param);
  }

  async fnGetStatusList() {
    const statusCd = 'S307';
    const url = '/expert-analyze/status/list.do';
    const param = {
      statusCd: statusCd,
    };
    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      } else {
        this.setSelectBoxData(
          [...response].sort(function (a, b) {
            return a.seq < b.seq ? -1 : a.seq > b.seq ? 1 : 0;
          })
        );
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  // 전문가 컨설팅 신청
  async fnApplyExpertConsulting(params) {
    const url = '/expert-consult/apply.do';
    const param = {
      taskNm: params.taskNm,
      cnsltDmndDt: params.cnsltDmndDt,
      exprtAnlsId: params.exprtAnlsId,
      exprtSn: params.exprtSn,
      entSn: params.entSn,
      entNm: params.entNm,
      tpbizTypeNm: params.tpbizTypeNm,
      userNm: params.userNm,
    };

    const response = await dbPost(url, param);
    this.modalService.successAlert('컨설팅신청이 완료 되었습니다.');
  }

  async valueObjChange(model, value) {
    this.setValueObj({ ...this.valueObj, [model]: value });
  }

  async gridHeaderClick(col) {}

  gridCellClick(row, col) {
    const rowData = this.gridRef.current.getRowObj(row);
    const target = event.target;

    if (
      target.tagName === 'BUTTON' &&
      col === 'cnsltSttsNm' &&
      rowData.cnsltSttsCd === 'EXPRT05'
    ) {
      this.fnApplyExpertConsulting(rowData).then(() => {
        this.fnSearch();
      });
    }
  }

  gridCellDblClick(row, col, rowData) {
    this.navigate('/expert/consult/detail', {
      state: {
        rowData: rowData,
      },
    });
  }
}

export default ExpertConsultController;
